module.exports = __webpack_public_path__ + "static/media/img_photo-1.b81c9b82.png";